import script from "./EOldResultAnalyzes.vue?vue&type=script&setup=true&lang=ts"
export * from "./EOldResultAnalyzes.vue?vue&type=script&setup=true&lang=ts"

import "./EOldResultAnalyzes.vue?vue&type=style&index=0&id=7065aa13&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7065aa13"]])

export default __exports__